// src/components/EnseignantDrawer.jsx
import { useLocation } from "react-router-dom";
import { useEnseignantDrawer } from "../context/EnseignantDrawerContext";
import logo from "../assets/images/logo.png";

// ─── NAV ITEM ──────────────────────────────────────────────────────────
function NavItem({ icon, label, active, badge, onClick }) {
  return (
    <button className={`ni-drawer ${active ? "active" : ""}`} onClick={onClick}>
      <i className={`ti ${icon}`} />
      <span className="drawer-label">{label}</span>
      {!!badge && <span className="drawer-badge">{badge}</span>}
    </button>
  );
}

// ─── DRAWER GLOBAL ─────────────────────────────────────────────────────
// Rendu une seule fois dans EnseignantLayout, piloté par le contexte.
// N'importe quelle page peut l'ouvrir via useEnseignantDrawer().openDrawer().
export default function EnseignantDrawer({
  username,
  badges,
  getEnseignantPath,
  onNavigate,
  onLogoutClick,
}) {
  const { drawerOpen, closeDrawer } = useEnseignantDrawer();
  const location = useLocation();

  const isActive = (path) => location.pathname === getEnseignantPath(path);

  const go = (path) => {
    closeDrawer();
    onNavigate(getEnseignantPath(path));
  };

  return (
    <>
      <div
        className={`drawer-overlay ${drawerOpen ? "open" : ""}`}
        onClick={closeDrawer}
      />
      <div className={`drawer ${drawerOpen ? "open" : ""}`}>
        <div className="drawer-header">
          <div className="drawer-logo-wrapper">
            <img src={logo} alt="Logo" className="drawer-logo" />
          </div>
          <div className="drawer-brand">
            <span className="drawer-title">Suivi Scolaire</span>
            <span className="drawer-subtitle">Espace Enseignant</span>
          </div>
        </div>

        <nav className="drawer-nav">
          <div className="drawer-user">
            <div className="drawer-avatar">
              <i className="ti ti-user" />
            </div>
            <div className="drawer-user-info">
              <span className="drawer-username">{username}</span>
              <span className="drawer-user-role">Enseignant</span>
            </div>
          </div>

          <div className="drawer-divider" />

          <NavItem
            icon="ti-home"
            label="Accueil"
            active={isActive("accueil")}
            onClick={() => go("accueil")}
          />
          <NavItem
            icon="ti-user-check"
            label="Faire l'appel"
            active={isActive("faire-appel")}
            onClick={() => go("faire-appel")}
          />
          <NavItem
            icon="ti-clock"
            label="Historique"
            active={isActive("historique")}
            badge={badges?.notifications}
            onClick={() => go("historique")}
          />
          <NavItem
            icon="ti-user-circle"
            label="Mon profil"
            active={isActive("profil")}
            onClick={() => go("profil")}
          />

          <div className="drawer-divider" />

          <div className="drawer-logout-wrapper">
            <button className="drawer-logout-btn" onClick={onLogoutClick}>
              <i className="ti ti-logout" />
              Déconnexion
            </button>
          </div>

        </nav>
      </div>
    </>
  );
}